/* 布局 */
//前台
import Layout from "@views/layout";

const teauserlevelRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
        path: "teauserlevel/list",
        name: "TEAUSERLEVEL",
        meta: {
            title: "教师评级表",
        },
        component: () => import("@views/business/teauserlevel/index.vue"),
    },
        ],
};

export default teauserlevelRouter;
